import { useEffect, useState } from 'react';
import AgoraSingleton from 'MentalHealth/components/AudioVideoCallComponent/AgoraSingleton';

const useAgoraUsers = () => {
  const [users, setUsers] = useState([]);
  const [callStart, setStart] = useState(false);
  const [currentCallType, setCurrentCallType] = useState('');
  const [inCall, setInCall] = useState(false);
  const [options, setOptions] = useState('');
  const [initialNameLetters, setInitialNameLetters] = useState('');
  const [remoteConnectionState, setRemoteConnectionState] = useState({
    audio: true,
    video: true,
  });
  const [time, setTime] = useState(0);
  const [tracks, setTracks] = useState([]);
  const [ready, setReady] = useState(false);
  const [channelName, setChannelName] = useState('');
  const [isEnd, setIsEnd] = useState(false);
  const [isMicMuted, setIsMicMuted] = useState(false);
  const [isCameraOff, setIsCameraOff] = useState(false);

  const agoraInstance = AgoraSingleton.getInstance();

  useEffect(() => {
    // Synchronize local state with Agora instance
    const syncStates = () => {
      setStart(agoraInstance.start);
      setUsers(agoraInstance.users || []);
      setTracks(agoraInstance.tracks || []);
      setRemoteConnectionState(agoraInstance.remoteConnectionState || {
        audio: true,
        video: true,
      });
      setOptions(agoraInstance.currentOption || '');
      setInitialNameLetters(agoraInstance.initialName || '');
      setChannelName(agoraInstance.channelName || '');
      setReady(agoraInstance.ready || false);
      setTime(agoraInstance.time || 0);
      setInCall(agoraInstance.inCall || false);
      setIsEnd(agoraInstance.isEnd || false);
      setIsMicMuted(agoraInstance.isMicMuted || false);
      setIsCameraOff(agoraInstance.isCameraOff || false);
    };

    // Perform an initial synchronization
    syncStates();

    // Set up observers
    const observers = [
      { event: 'callType', handler: setCurrentCallType },
      { event: 'users', handler: (newUsers) => setUsers([...newUsers]) },
      { event: 'start', handler: setStart },
      { event: 'inCall', handler: setInCall },
      { event: 'remoteConnectionState', handler: setRemoteConnectionState },
      { event: 'time', handler: setTime },
      { event: 'currentOption', handler: setOptions },
      { event: 'initialName', handler: setInitialNameLetters },
      { event: 'tracks', handler: (newTracks) => setTracks([...newTracks]) },
      { event: 'ready', handler: setReady },
      { event: 'channelName', handler: setChannelName },
      { event: 'isEnd', handler: setIsEnd },
      { event: 'isMicMuted', handler: setIsMicMuted },
      { event: 'isCameraOff', handler: setIsCameraOff },
      {
        event: 'endCall',
        handler: (endCall) => {
          setIsEnd(endCall)
          setInCall(false)
          setStart(false)
          setTracks([])
          setUsers([])
          setReady(false)
        },
      },
    ]

    observers.forEach(({ event, handler }) =>
      agoraInstance.addObserver(event, handler)
    );

    return () => {
      // Remove all observers when component unmounts
      observers.forEach(({ event, handler }) =>
        agoraInstance.removeObserver(event, handler)
      );
    };
  }, [agoraInstance]);

  return {
    users,
    callStart,
    remoteConnectionState,
    agoraInstance,
    setStart,
    inCall,
    setInCall,
    time,
    options,
    initialNameLetters,
    ready,
    setCurrentCallType,
    currentCallType,
    tracks,
    channelName,
    isEnd,
    isMicMuted,
    isCameraOff,
  };
};

export default useAgoraUsers;
